<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-contact-reasons-update-topic">
    <el-dialog
      v-if="visible"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      append-to-body
      custom-class="topicNameConflictDialog">
      <div class="update-topic-name"  v-loading="loading">
        <div class="div-topic-icon"></div>
        <div class="div-topic-label">Hmmm, I found another topic with the same name.</div>
        
        <div class="div-topic-name-input">
          <el-input ref="topicNameInput" placeholder="" v-model="topicName" autofocus="true" @keypress.enter.native="handleUpdateName"></el-input>
        </div>
        <div v-if="isDuplicatedError" class="red-warning">
          The conversation topic "{{topicName}}" exists.
        </div>
        <div class="conflict-msg">Try to use merge instead.</div>
        <div slot="footer" class="dialog-footer">
          <div class="div-cancel-btn"><el-button class="btn-cancel" @click="handleClose">Cancel</el-button></div>
          <div class="div-confirm-btn"><el-button v-if="!isDisabled" class="btn-confirm" type="primary" @click="handleUpdateName">Confirm Changes</el-button></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-update-topic',
  props: ['controller'],

  data() {
    return {
      visible: false,
      currentRow: null,
      topicName: '',
      topicNameObject: null,
      isDuplicatedError: false,
      loading: false
    }
  },

  computed: {
    isDisabled() {
      return this.topicName.trim()=='' || this.topicName.trim() == this.topicNameObject.newTopicDisplayName || this.topicName.trim() == this.topicNameObject.oldTopicDisplayName;
    }
  },

  methods: {
    handleUpdateName() {
      if(this.controller.updateTableData) {
        this.loading = true;
        this.controller.updateTableData(this.currentRow, "topicDisplayName", this.topicName.trim(), ({error}) => {
          if(error) {
            this.isDuplicatedError = error;
          }
          else {
            this.handleClose();
          }
          this.loading = false;
        });
      }
    },

    handleOpen(row, topicNameObject) {
      this.currentRow = row;
      this.topicName = topicNameObject.newTopicDisplayName;
      this.topicNameObject = topicNameObject;
      this.visible = true;
    },

    handleClose() {
      this.visible = false;
    }
  },

  created() {
    this.topicName = this.controller.topicName;
  }
});
</script>

<style lang="scss">
.topicNameConflictDialog.el-dialog {
    width: 567px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 6px #0000000A;
    border: 2px solid #214586;
    border-radius: 25px;
    
  .el-dialog__body {
    padding: 0px 20px 30px 20px;
  }
  .div-topic-icon {
    background-image: url('../../assets/icons/icon_warning_wys.png') !important;
    background-size: 135px;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 30px;
    height: 168px;
    width: 30%;
    text-align: center;
    padding: 0px 46px 25px 0px;
    font-weight: 600;
    display: inline-block;
  }
  .div-topic-label {
    display: inline-block;
    font-weight: 500;
    font-size: 21px;
    color: var(--site-font-primary-color);
    width: 280px;
    word-break: keep-all;
    vertical-align: 63px;
  }
  .div-topic-name-input {
    padding: 0px 37px;

    input.el-input__inner {
      border-width: 0px 0px 3px 0px !important;
      border-radius: 0;
      padding-left: 5px;
      border: 3px solid #214586;
      font-size: 18px;
      color: var(--site-font-primary-color);
      font-weight: 400;
    }
  } 
  .red-warning {
    text-align: left;
    // font: italic normal normal 13px/16px Lato;
    font-style: italic;
    font-size: 11px;
    letter-spacing: 0px;
    color: #D54545;
    opacity: 1;
    padding-left: 37px;
    padding-top: 7px;
  }
  .conflict-msg {
    text-align: center;
    padding: 30px 0px;
    font-size: 18px;
    color: var(--site-font-primary-color);
    font-weight: 400;
  }
  .el-dialog__header {
    padding: 5px 20px 10px;
  }
  .dialog-footer {
    text-align: right;
    margin-top: 10px;
    margin-right: 50px;
    .btn-cancel {
      // float: left;
      border: 1px solid transparent;
      color: var(--site-font-primary-color);
      padding: 7px 30px 7px 30px;
    }
    .btn-cancel:hover {
      border: 1px solid #DCDFE6;
      // color: #214586;
      background-color: transparent;
      padding: 7px 30px 7px 30px;
    }
    .btn-confirm {
      // float: right;
      background-color: #214586;
      padding: 7px 30px 7px 30px;
    }
    .div-cancel-btn {
      display: inline-block;
    }
    .div-confirm-btn {
      display: inline-block;
      width: 158px;
    }
  }
}
</style>